import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { useFetchData } from 'hooks/apiHooks';
import { API_ENDPOINTS } from 'constants';
import { OBJ } from 'constants';

const supportedTypes = [
    OBJ.CUSTOMERS,
    OBJ.COMPANIES,
    OBJ.EMAILS,
    OBJ.CHAT_DESIGNS,
    OBJ.OBJECT,
    OBJ.ROLES,
    OBJ.EVENTS,
    OBJ.COMMUNICATION_PLANS,
];

const ObjectSelectorInput = ({ value, obj, linkValue }) => {
    const { makeApiCall} = useFetchData();
    const [objName, setObjName] = useState(null);
    const type = typeof obj === 'string' ? obj : obj.type

    useEffect(() => {
        if (value && supportedTypes.includes(type) && !objName) {
            getName()
        }
    }, [value]);

    const getName = async () => {
        try {
            if(linkValue){
                setObjName(linkValue) 
                return
            }

            const {data: objData} = await makeApiCall(API_ENDPOINTS[type.toUpperCase()].ITEM(value), null, null, null, ()=>{}, 'GET')
            switch(type){
                case OBJ.EMAILS:
                    setObjName(objData.subject) 
                    break;
                case OBJ.CUSTOMERS:
                case OBJ.COMPANIES: 
                    if (objData.entity_type === 'Person') {
                        const first = objData.firstname?.trim();
                        const last = objData.lastname?.trim();
                
                        if (first && last) setObjName(`${first} ${last}`);
                        else if (first || last) setObjName(first || last);
                        else setObjName('n/a');
                    } else {
                        setObjName(objData.name || 'n/a');
                    }
                break;
                case OBJ.CHAT_DESIGNS:
                case OBJ.EVENTS:
                    setObjName(objData.name) 
                    break;
                case OBJ.OBJECT:
                    setObjName(objData.table_name || 'n/a') 
                    break;
                case OBJ.ROLES:
                case OBJ.COMMUNICATION_PLANS:
                    setObjName(objData.name) 
                    break;
            }
        } catch (error) { 
            console.error(error, type)
        }
    }
    if(!objName) return null

    return <Input readOnly={true} value={objName} style={{marginTop:'4px', height:"38px", maxWidth:"13em"}}/>
};

export default ObjectSelectorInput;
